//get candidate detail
export const GET_VIDEO_RESUME= "GET_VIDEO_RESUME"
export const GET_VIDEO_RESUME_SUCCESSFULL = "GET_VIDEO_RESUME_SUCCESSFULL"
export const GET_VIDEO_RESUME_FAILED = "GET_VIDEO_RESUME_FAILED"